module.exports = __webpack_public_path__ + "img/vue.242f11e9.svg";